import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const GiftSetNameForm = ({
  error,
  groupName,
  isPairing,
  isSavingName,
  onChange,
  onSave,
  theme,
}) => (
  <>
    <label className="mt-4 block rounded-[1.1rem] border p-4" style={{ borderColor: theme.cardBorder, backgroundColor: theme.cardBg }}>
      <span className="mb-1 block text-[9px] font-black uppercase tracking-widest" style={{ color: theme.accent }}>
        Gift Group Name
      </span>
      <span className="mb-3 block text-[11px] font-bold leading-relaxed opacity-55">
        This name appears while pairing member NFCs, so you can tell which master gift is active.
      </span>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-[1fr,auto]">
        <input
          value={groupName}
          onChange={(event) => onChange(event.target.value)}
          maxLength={80}
          className="lumirae-ds-input w-full p-4 text-sm font-medium placeholder:text-[#9B9491]"
          placeholder="Name this set, e.g. wedding table favors"
        />
        <button
          type="button"
          onClick={onSave}
          disabled={isSavingName || isPairing}
          className="lumirae-ds-button lumirae-ds-button-secondary px-4 py-3 text-[10px] disabled:opacity-60"
        >
          {isSavingName ? <FaSpinner className="animate-spin" /> : 'Save'}
        </button>
      </div>
    </label>

    {error && (
      <div
        className="mt-4 rounded-[1.1rem] border p-3 text-xs font-bold leading-relaxed"
        style={{ borderColor: theme.stateError, color: theme.stateError }}
      >
        {error}
      </div>
    )}
  </>
);

export default GiftSetNameForm;
